/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_No_Methods_DescriptionInputs */

const en_common_sign_no_methods_description = /** @type {(inputs: Common_Sign_No_Methods_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The administrator hasn't enabled any sign-in methods yet. Please check back later.`)
};

/**
* | output |
* | --- |
* | "The administrator hasn't enabled any sign-in methods yet. Please check back later." |
*
* @param {Common_Sign_No_Methods_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_sign_no_methods_description = /** @type {((inputs?: Common_Sign_No_Methods_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_No_Methods_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_sign_no_methods_description(inputs)
});
export { common_sign_no_methods_description as "common.sign.no_methods_description" }